import React from 'react';
import { Dispatch, GlobalState } from "./GlobalState.types";

export const GlobalStateContext = React.createContext<GlobalState>({});

export const DispatchStateContext = React.createContext<Dispatch | undefined>(undefined);

